import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from "@material-ui/core/styles";
import {Provider} from 'react-redux'
import {store} from './store'
import App from './App'
import * as serviceWorker from './serviceWorker'
//import {mocBackend} from './functions/_helpers/backend-mock';
//const Context = React.createContext();
//mocBackend();
ReactDOM.render(
      <Provider store={store}>
      <App />
    </Provider>,
  document.getElementById('root')
)
//connect(mapStateA, null, null, {context: Context})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
